/* eslint-disable react/require-default-props */
/* eslint-disable react/no-unused-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const ModalFooter = React.forwardRef((props, ref) => {

  const { children, position = 'center', ...other } = props;

  const classes = classNames('sui-flex sui-align-center sui-p-4 sui-grow-0 sui-shrink-0 sui-basis-auto', {
    'sui-justify-start': position === 'start',
    'sui-justify-end': position === 'end',
    'sui-justify-center': position === 'center'
  });

  return (
    <div
      className={classes}
      ref={ref}
      {...other}
    >
      {children}
    </div>
  );
});

ModalFooter.displayName = 'ModalFooter';

ModalFooter.propTypes = {
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * The position of the content
   */
  position: PropTypes.string
};

export { ModalFooter };